import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";
import {ProfileUserComponent} from "../profile-user.component";
import {UserService} from "../../../../_services/user.service";
import {AuthenticationService} from "../../../../_services/authentication.service";

@Component({
    selector: 'app-change-module',
    templateUrl: './change-module.component.html',
    styleUrls: ['./change-module.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class ChangeModuleComponent extends DialogComponent<ProfileUserComponent, boolean> implements OnInit {

    loading = false;
    modulesAlls: any = [];
    model: any = {};
    message: string;
    connect: string;
    messageChangeModule = 'あなたは使用している機能パッケージを変更しました。システムに再ログインするす必要があります。機能パッケージの変更要求がシステムアドミンとあなたのメールに送信されました。メールを確認お願いいたします。';

    constructor(dialogService: DialogService,
                private router: Router,
                private userService: UserService,
                private authenticationService: AuthenticationService) {
        super(dialogService);
    }

    ngOnInit() {
        this.userService.getAllModules().subscribe(res => {
            this.modulesAlls = res;
        });
    }

    save() {
        this.model.moduleId = $('#modules').val();
        this.loading = true;
        this.message = '';
        this.userService.userUpdateModule(this.model).subscribe(data => {
            this.connect = data.connect;
            if (data.error == true && data.module == true) {
                $("label.error").fadeIn(300).delay(3000).fadeOut(400);
                $("div.line-user").hide();
            }
            if (data.error == true && data.lineUser == true) {
                $("div.line-user").css('display', 'block');
            }
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
                alert(this.messageChangeModule);
                this.authenticationService.logout();
                this.router.navigate(["/login"]);
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/profile-user/change-module/change-module.component.ts